import { render, staticRenderFns } from "./SendBundleSaveRegi.vue?vue&type=template&id=3d5b9330&scoped=true&"
import script from "./SendBundleSaveRegi.vue?vue&type=script&lang=js&"
export * from "./SendBundleSaveRegi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b9330",
  null
  
)

export default component.exports